<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="items"
            disable-initial-sort
            item-key="id"
            :search="search"
            :rows-per-page-items="rowPerPage"
            :loading="loader"
        >
            <template #headers="props">
                <tr>
                    <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template #items="props">
                <tr>

                    <td class="text-center">
                        <v-menu offset-y>
                            <v-btn icon slot="activator">
                                <v-icon small color="#464D69">settings</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list-tile @click="showChangeDetail(props.item)">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-assignment"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Xem chi tiết</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="props.item.is_valid" @click="cancelReceipt(props.item)">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-delete"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Hủy phiếu</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-else @click="deletelReceipt(props.item)">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-delete"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Xóa phiếu</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </td>
                    <td class="text-left text-no-wrap">{{ props.item.change_id }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.date_created | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.date_change | formatTimeServer }}</td>
                    <td v-if="props.item.is_valid" class="text-center text-no-wrap">
                        <span :class="['v-badge', props.item.is_change ? 'primary' : 'warning']">
                            {{ props.item.is_change ? "Đã áp dụng" : "Chưa áp dụng"}}
                        </span>
                    </td>
                    <td v-else class="text-center text-no-wrap">
                        <span class="v-badge error">Đã hủy</span>
                    </td>
                    <td class="text-left text-no-wrap">{{ props.item.note }}</td>
                    <td class="text-no-wrap">{{ props.item.name }}</td>
                    <td class="text-no-wrap">{{ props.item.phone}}</td>
                    <td class="text-no-wrap">{{ props.item.motorbike}}</td>
                    <td class="text-center text-no-wrap">{{ props.item.washing_machine_text }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.air_conditioner_text }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.internet_price }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.room_state_id }}</td>
                    <!-- <td class="text-center text-no-wrap">
                        <v-btn flat icon color="primary">
                            <v-icon class="zmdi zmdi-edit"></v-icon>
                        </v-btn>
                    </td> -->
                </tr>
            </template>
        </v-data-table>

        <v-dialog v-if="dialogDetail" v-model="dialogDetail" max-width="900px">
            <app-card>
                <h4>CHỨNG TỪ: {{ chosen_receipt.change_id }} - SỐ PHÒNG: {{ chosen_receipt.room_id }}</h4>
                <p class="fs-14 my-1 grey--text">Trạng thái:
                    <span :class="['v-badge', chosen_receipt.is_change ? 'primary' : 'warning']">
                        {{ chosen_receipt.is_change ? "Đã áp dụng" : "Chưa áp dụng"}}
                    </span>
                </p>
                <p class="fs-14 my-1 grey--text">Diễn giải: {{ chosen_receipt.note }}</p>
                <p class="fs-14 my-1 grey--text">Ngày tạo phiếu: {{ chosen_receipt.date_created | formatTimeServer }}</p>
                <p class="fs-14 my-1 grey--text">Ngày áp dụng: {{ chosen_receipt.date_change | formatTimeServer }}</p>
                <change-detail :change_data="chosen_receipt"></change-detail>
            </app-card>
        </v-dialog>
        <print-portal layout="landscape" :open="print_table" @close="print_table = false">
            <print-phieu-thay-doi-thong-tin :items="items"></print-phieu-thay-doi-thong-tin>
        </print-portal>
        
        <export-csv-button
            :trigger="export_csv.trigger"
            :title="export_csv.title"
            :rows="export_csv.rows"
        ></export-csv-button>
    </div>
</template>

<script>

import api from "Api";
import { buildParamQuery, formatTimeServer, deepCopy } from 'Helpers'
import ChangeDetail from './ChangeDetail'
import PrintPortal from 'Components/Print/PrintPortal';
import PrintPhieuThayDoiThongTin from 'Components/Print/PrintPhieuThayDoiThongTin';
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton.vue'

export default {
    name: "table-phieu-thay-doi-thong-tin",
    components: {
        ChangeDetail,
        PrintPortal,
        PrintPhieuThayDoiThongTin,
        ExportCsvButton
    },
    props: {
        getDataProp: Number,
        print: Number,
        search: String,
        date_start: String,
        date_end: String,
        loader: Boolean,
        chosen_building: String
    },
    data(){
        return {
            headers: [
                { text: "Thao tác", align: "center", sortable: false },
                { text: "#Chứng từ", align: "center", sortable: false, value: "change_id" },
                { text: "Số phòng", align: "center", sortable: false, value: "room_id" },
                { text: "Ngày nhập", align: "center", sortable: false, value: "date_created" },
                { text: "Ngày áp dụng", align: "center", sortable: false, value: "date_change" },
                { text: "Trạng thái", align: "center", sortable: false, value: "is_change" },
                { text: "Diễn giải", align: "left", sortable: false, value: "note" },
                { text: "Tên thành viên", align: "left", sortable: false, value: "name" },
                { text: "SDT", align: "left", sortable: false, value: "phone" },
                { text: "Số xe", align: "left", sortable: false, value: "motorbike" },
                { text: "Máy giặt", align: "center", sortable: false, value: "washing_machine" },
                { text: "Máy lạnh", align: "center", sortable: false, value: "air_conditioner" },
                { text: "Giá internet", align: "center", sortable: false, value: "internet_price" },
                { text: "#Ref", align: "center", sortable: false, value: "room_state_id" },
                // {
                //     text: "Điều Chỉnh",
                //     align: "center",
                //     sortable: false
                // }
            ],
            items: [],
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            dialogDetail: false,
            chosen_receipt: {},
            print_table: false,
            export_csv: {
                loading: false,
                trigger: false,
                title: "PhieuThayDoiThongTin",
                rows: []
            },
        }
    },
    watch: {
        getDataProp(){
            this.getData()
        },
        print(){
            this.print_table = true;
        },
        date_start: function(nv){
            if (nv && this.date_end) this.getData()
        },
        date_end: function(nv){
            if (nv && this.date_start) this.getData()
        },
        chosen_building: function(nv){
           this.getData();
        }
    },
    created(){
        this.getData()
    },
    methods: {
        getData: async function (){
            this.$emit('loading', true)
            this.items = []
            const params = {
                building: this.chosen_building,
                // [this.search_type]: this.search,
                dateStart: this.date_start,
                dateEnd: this.date_end,
            }
            const query = buildParamQuery(params)
            let data = await api.getReceiptChange(query)
            this.$emit('loading', false)
            if ( data.status === 200){
                this.items = data.data.map(receipt => this.handleReceiptData(receipt))
            }
        },
        handleReceiptData: function (receipt){
            receipt.month = new Date(receipt.date_change).toISOString().substr(0, 7);

            receipt.new_data = deepCopy(receipt.old_data)
            
            // receipt.new_data.customers.forEach(customer => {
            //     if (customer.motorbike_list && customer.motorbike_list.length){
            //         customer.motorbike_list.forEach(device => {
            //             if (customer.motorbike) customer.motorbike += ", " + device.name.trim()
            //             else customer.motorbike = device.name.trim()
            //         })
            //     }
            //     console.log(customer.motorbike);
            // })

            let name = ''
            let motorbike = ''
            let phone = ''

            for (const key in receipt.change_request) {
                if (receipt.change_request.hasOwnProperty(key)) {
                    const requests = receipt.change_request[key];
                    if (key === 'add'){
                        requests.forEach(request => {
                            if (request.type === 'CUSTOMER'){
                                name += request.name + ", "
                                motorbike += request.motorbike ? request.motorbike + ", " : ''
                                motorbike += request.bike ? "xe đạp, " : ''
                                phone += request.phone ? request.phone + ", " : ''

                                request.is_changed_name = !!request.name
                                request.is_changed_phone = !!request.phone
                                request.is_changed_motorbike = true
                                request.is_changed_bike = true
                                receipt.new_data.customers.push(request)

                            } else if (request.type === 'B' || request.type === 'MB'){
                                const customer = receipt.new_data.customers.find(cus => cus.customer_id === request.customer_id)
                                name += customer.name + ", "
                                motorbike += request.name ? request.name  + ", " : 'xe đạp, '
                                customer.motorbike = request.name ? request.name : customer.motorbike;
                                customer.bike = request.type === 'B'
                                
                                customer.is_changed_motorbike = request.type === 'MB'
                                customer.is_changed_bike = request.type === 'B'

                                if (customer.motorbike && request.type === 'MB'){
                                    customer.motorbike += ", " + request.name.trim()
                                } else if (!customer.motorbike && request.type === "MB"){
                                     customer.motorbike = request.name.trim()
                                }

                            } else {
                                request.type == "WM" ? receipt.washing_machine_text = 'có' : receipt.washing_machine_text = ''
                                receipt.new_data.washing_machine = true
                            }
                        })
                    } else if (key === 'edit'){
                        requests.forEach(request => {
                            const customer = receipt.new_data.customers.find(cus => cus.customer_id === request.customer_id)
                            if (request.type === 'CUSTOMER'){
                                customer.is_changed_name = customer.name !== request.name
                                customer.is_changed_phone = customer.phone !== request.phone
                                customer.name = request.name;
                                customer.phone = request.phone;

                                name += request.name + ", "
                                phone += request.phone ? request.phone + ", " : ''
                            } else if (request.type === 'MB'){
                                customer.is_changed_motorbike = true
                                
                                customer.motorbike = this.handleMotorbike(customer, request, "edit")

                                name += customer ? customer.name + ", " : ''
                                motorbike += request.name ? request.name + ", " : 'xe đạp, '
                            }
                        })
                    } else if (key === 'remove'){
                        requests.forEach(request => {
                            if (request.type === 'CUSTOMER' || request.type === 'MB' || request.type === 'B'){
                                const customer = receipt.new_data.customers.find(cus => cus.customer_id === request.customer_id)
                                if (request.type === 'CUSTOMER'){
                                    customer.is_deleted = true
                                    customer.is_changed_motorbike = !!customer.motorbike
                                    customer.is_changed_bike = !!customer.bike
                                    customer.is_changed_name = true
                                    customer.is_changed_phone = !!customer.phone
                                }

                                if (request.type === 'MB' && customer){
                                    customer.is_changed_motorbike = true
                                    
                                    customer.motorbike = this.handleMotorbike(customer, request, "remove")
                                }

                                if (request.type === 'B'){
                                    customer.is_changed_bike = true
                                    customer.motorbike = false
                                }

                                if (!name.includes(customer.name)) name += customer.name + ", "
                                if (!phone.includes(customer.phone)) phone += customer.phone ? customer.phone + ", " : ''
                                if (!motorbike.includes(customer.motorbike)) motorbike += customer.motorbike ? customer.motorbike + ", " : ''
                                motorbike += customer.bike ? "xe đạp, " : ''
                            }  else {
                                request.type == "WM" ? receipt.washing_machine_text = 'không' : receipt.washing_machine_text = ''
                                receipt.new_data.washing_machine = false
                            }
                        })
                    }
                }
            }

            receipt.name = name ? name.slice(0, -2) : name
            receipt.phone = phone ? phone.slice(0, -2) : phone
            receipt.motorbike = motorbike ? motorbike.slice(0, -2) : motorbike

            return receipt
        },

        showChangeDetail: function (receipt){
            this.chosen_receipt = {
                ...receipt.new_data,
                old_data: receipt.old_data,
                room_id: receipt.room_id,
                change_id: receipt.change_id,
                note: receipt.note,
                is_change: receipt.is_change,
                date_created: receipt.date_created,
                date_change: receipt.date_change
            }
            this.dialogDetail = true
        },
        handleMotorbike: function (customer, request, type){
            let motorbike_list = customer.motorbike ? customer.motorbike.split(",") : []
            motorbike_list = motorbike_list.map(name => (name.trim()))

            if (customer.motorbike_list) {
                if (type === "edit"){
                    const old_device = customer.motorbike_list.find(device => device._id == request.device_id)
                    if (old_device && old_device.name){
                        motorbike_list.forEach((name, index) => {
                            if (name ==  old_device.name) motorbike_list[index] = request.name
                        })
                    }
                }
                if (type === "remove"){
                    const old_device = customer.motorbike_list.find(device => device._id == request.device_id)
                    if (old_device && old_device.name){
                        motorbike_list.forEach((name, index) => {
                            if (name ==  old_device.name) motorbike_list[index] = request.name
                        })
                    }
                }
            } else {
                if (type == "edit") return request.name
                if (type == "remove") return "Không"
            }

            return motorbike_list.filter(name => name).join(", ")
        },
        cancelReceipt(receipt){
            let that = this
            swal.fire({
            title: 'Hủy Phiếu thay đổi thông tin',
            text: `Bạn có chắc muốn hủy phiếu thay đổi thông tin:\n\nMã chứng từ: ${receipt.change_id}\nSố phòng ${receipt.room_id} ?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Hủy phiếu',
            cancelButtonText: 'Trở về'
            }).then(async (result) => {
                if (result.value) {
                    that.$store.commit("loading", true)
                    let data = await api.cancelReceiptChange({change_id: receipt.change_id})
                    that.$store.commit("loading", false)
                    if (data.status == 200){
                        swal.fire('Thành công', data.data.message, 'success')
                        receipt.is_valid = false
                    } else {
                        swal.fire('Lỗi', data.message, 'error')
                    }
                }
            })
        },
        deletelReceipt(receipt){
            let that = this
            swal.fire({
            title: 'Xóa Phiếu thay đổi thông tin',
            text: `Bạn có chắc muốn xóa hoàn toàn phiếu thay đổi thông tin:\n\nMã chứng từ: ${receipt.change_id}\nSố phòng ${receipt.room_id} ?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Xóa phiếu',
            cancelButtonText: 'Trở về'
            }).then(async (result) => {
                if (result.value) {
                    that.$store.commit("loading", true)
                    let data = await api.deleteReceiptChange({change_id: receipt.change_id})
                    that.$store.commit("loading", false)
                    if (data.status == 200){
                        swal.fire('Thành công', data.data.message, 'success')
                        that.getData()
                    } else {
                        swal.fire('Lỗi', data.message, 'error')
                    }
                }
            })
        },
        exportCSV: function() {
            this.export_csv.rows = this.items.map(receipt => ({
                'Mã chứng từ': receipt.change_id,
                'Số phòng': receipt.room_id,
                'Tòa nhà': receipt.building,
                'Tên khách hàng': receipt.name || '',
                'Số điện thoại': receipt.phone || '',
                'Xe máy': receipt.motorbike || '',
                'Xe đạp': receipt.bike ? 'Có' : 'Không',
                'Máy giặt': receipt.washing_machine_text || '',
                'Máy lạnh': receipt.air_conditioner_text || '',
                'Trạng thái': receipt.is_change ? 'Đã áp dụng' : 'Chưa áp dụng',
                'Ngày tạo': new Date(receipt.date_created).toLocaleDateString('vi-VN'),
                'Ngày áp dụng': new Date(receipt.date_change).toLocaleDateString('vi-VN'),
                'Ghi chú': receipt.note || ''
            }));
            this.export_csv.trigger = !this.export_csv.trigger;
        }
    }
}
</script>

<style scoped>
    .v-list__tile__action {
        min-width: 30px;
    }
</style>